import styled from 'styled-components';

import { ExclamationCircleOutlined } from '@ant-design/icons';

import { BodilColor } from '~src/branding';
import { Anchor } from '~src/components/Anchor';
import { Button } from '~src/components/Button';
import { Heading, Text } from '~src/components/Typography';
import { getBookingURLByLeadOrigin } from '~src/constants';
import { useDisplayContext } from '~src/context/DisplayContext';
import { usePublicCalculatorContext } from '~src/context/PublicCalculatorContext';

import { TakeoverProps } from './types';
import { getTakeoverInfo } from './util';

const CompactWrapper = styled.div({
  display: 'flex',
  flexFlow: 'row nowrap',
  alignItems: 'center',
  gap: '8px',
});

export const Takeover = ({ takeover, residence }: TakeoverProps) => {
  // leadOrigin: this "Book tid til rådgiver" was hardcoded to BODIL_BOOK_URL and
  // had the same problem as the header — a Jyske Bank or Nordea visitor was sent
  // to Bodil's generic page. (Norlys has its own variant beside this file.)
  const { isMobile, leadOrigin } = useDisplayContext();
  const { heading, text, subtext, button } =
    getTakeoverInfo(takeover, residence?.primaryHeating?.fuelType ?? '', isMobile) ?? {};
  const { setOpenStageMap, setStage, setHeaderExpanded } = usePublicCalculatorContext();

  const { stage = 0, text: buttonText } = button ?? {};
  const updateDesktopStage = () => setOpenStageMap?.({ [stage]: true });
  const updateMobileStage = () => {
    setStage(stage);
    setHeaderExpanded(false);
  };

  return (
    <div style={{ padding: '16px 0' }}>
      <ExclamationCircleOutlined style={{ color: BodilColor.ui.orange, fontSize: 32 }} />

      <Heading style={{ padding: '16px 0' }} color='light'>
        {heading}
      </Heading>

      <Text level={2} color='light' style={{ lineHeight: 2 }}>
        {text}
      </Text>

      <Text level={2} color='light' style={{ lineHeight: 2, marginTop: '16px' }}>
        {subtext}
      </Text>

      <div style={{ display: 'flex', justifyContent: 'center', gap: '16px', marginTop: '24px' }}>
        <Button type='callToAction' style={{ margin: 0 }} onClick={isMobile ? updateMobileStage : updateDesktopStage}>
          {buttonText}
        </Button>

        <Anchor newTab href={getBookingURLByLeadOrigin(leadOrigin)}>
          <Button type='callToAction' style={{ margin: 0 }} onClick={() => false}>
            Book tid til rådgiver
          </Button>
        </Anchor>
      </div>
    </div>
  );
};

export const CompactTakeover = ({ takeover, residence }: TakeoverProps) => {
  const { heading } = getTakeoverInfo(takeover, residence?.primaryHeating?.fuelType ?? '', true) ?? {};
  return (
    <CompactWrapper>
      <ExclamationCircleOutlined style={{ color: BodilColor.ui.orange, fontSize: 32 }} />

      <Heading style={{ padding: '16px 0' }} color='light'>
        {heading}
      </Heading>
    </CompactWrapper>
  );
};
